(function () {
  if (window.__sppCartDrawerV2Loaded) return;
  window.__sppCartDrawerV2Loaded = true;

  var refreshTimer = null;
  var recommendationsLoading = false;
  var preferredSeedProductId = null;
  var justAdded = false;

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function shopRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  function money(cents, currency) {
    var amount = Number(cents || 0) / 100;
    var code = currency || 'ZAR';
    try {
      return new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return 'R ' + amount.toFixed(2);
    }
  }

  function productImage(product) {
    var image = product && (product.featured_image || product.image);
    if (!image && product && product.featured_media && product.featured_media.preview_image) {
      image = product.featured_media.preview_image;
    }
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.url || image.src || '';
  }

  function firstAvailableVariant(product) {
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    if (!variants.length) return null;
    for (var i = 0; i < variants.length; i += 1) {
      if (variants[i].available !== false) return variants[i];
    }
    return null;
  }

  function setOpenState() {
    var drawer = getDrawer();
    var open = !!(drawer && drawer.classList.contains('active'));
    document.body.classList.toggle('spp-cart-drawer-open', open);

    if (!drawer) return;
    var heading = drawer.querySelector('.drawer__heading');
    if (heading) {
      heading.textContent = justAdded && open ? 'Added to cart' : 'Your Cart';
    }

    if (!open) justAdded = false;
  }

  function fixTaxNote() {
    var drawer = getDrawer();
    if (!drawer) return;
    var note = drawer.querySelector('.tax-note');
    if (!note) return;
    note.textContent = 'Shipping calculated at checkout.';
    note.classList.add('spp-tax-note-ready');
  }

  function cartUrl() {
    return shopRoot() + 'cart.js';
  }

  function recommendationsUrl(productId) {
    return shopRoot() + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=8&intent=related';
  }

  function getCart() {
    return fetch(cartUrl(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    });
  }

  function getRecommendations(productId) {
    return fetch(recommendationsUrl(productId), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load recommendations');
      return response.json();
    }).then(function (data) {
      return data && Array.isArray(data.products) ? data.products : [];
    });
  }

  function buildCard(product, currency) {
    var variant = firstAvailableVariant(product);
    if (!variant) return '';

    var url = product.url || (product.handle ? shopRoot() + 'products/' + product.handle : '#');
    var image = productImage(product);
    var price = variant.price != null ? variant.price : product.price;

    return [
      '<article class="spp-drawer-upsell__card">',
        '<a class="spp-drawer-upsell__media" href="', escapeHtml(url), '" aria-label="View ', escapeHtml(product.title), '">',
          image
            ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
            : '<span class="spp-drawer-upsell__placeholder">Smart Pick &amp; Pay</span>',
        '</a>',
        '<a class="spp-drawer-upsell__name" href="', escapeHtml(url), '">', escapeHtml(product.title), '</a>',
        '<div class="spp-drawer-upsell__price">', escapeHtml(money(price, currency)), '</div>',
        '<button type="button" class="spp-drawer-upsell__add" data-spp-upsell-variant="', escapeHtml(variant.id), '">+ Add to Cart</button>',
      '</article>'
    ].join('');
  }

  function insertRecommendations(products, currency) {
    var drawer = getDrawer();
    if (!drawer || !products.length) return;

    var host = drawer.querySelector('cart-drawer-items');
    if (!host || host.querySelector('.spp-drawer-upsell')) return;

    var cards = products.map(function (product) {
      return buildCard(product, currency);
    }).filter(Boolean).join('');

    if (!cards) return;

    var section = document.createElement('section');
    section.className = 'spp-drawer-upsell';
    section.setAttribute('aria-label', 'Related products');
    section.innerHTML = [
      '<div class="spp-drawer-upsell__head">',
        '<div>',
          '<div class="spp-drawer-upsell__eyebrow">Related products</div>',
          '<h3 class="spp-drawer-upsell__title">You may also like</h3>',
        '</div>',
      '</div>',
      '<div class="spp-drawer-upsell__grid">', cards, '</div>'
    ].join('');

    var form = host.querySelector('#CartDrawer-Form');
    if (form) form.insertAdjacentElement('afterend', section);
    else host.appendChild(section);
  }

  function loadRecommendations() {
    var drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('active') || drawer.classList.contains('is-empty')) return;
    if (drawer.querySelector('.spp-drawer-upsell') || recommendationsLoading) return;

    recommendationsLoading = true;

    getCart().then(function (cart) {
      if (!cart || !Array.isArray(cart.items) || !cart.items.length) return null;

      var currentProductIds = {};
      cart.items.forEach(function (item) {
        currentProductIds[String(item.product_id)] = true;
      });

      var seedId = preferredSeedProductId || cart.items[0].product_id;
      if (!seedId) return null;

      return getRecommendations(seedId).then(function (products) {
        var filtered = products.filter(function (product) {
          return product && product.available !== false && !currentProductIds[String(product.id)] && firstAvailableVariant(product);
        }).slice(0, 3);

        insertRecommendations(filtered, cart.currency || 'ZAR');
        return filtered;
      });
    }).catch(function (error) {
      console.warn('SPP drawer recommendations:', error);
    }).finally(function () {
      recommendationsLoading = false;
    });
  }

  function refreshDrawerEnhancements() {
    fixTaxNote();
    setOpenState();
    loadRecommendations();
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshDrawerEnhancements, 120);
  }

  function makeAddConfig(formData) {
    return {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData,
      credentials: 'same-origin'
    };
  }

  function addUpsell(button) {
    if (!button || button.disabled) return;
    var variantId = button.getAttribute('data-spp-upsell-variant');
    if (!variantId) return;

    var drawer = getDrawer();
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      formData.append('sections', drawer.getSectionsToRender().map(function (section) {
        return section.id;
      }).join(','));
      formData.append('sections_url', window.location.pathname);
    }

    var addUrl = window.routes && window.routes.cart_add_url
      ? window.routes.cart_add_url
      : shopRoot() + 'cart/add.js';

    fetch(addUrl, makeAddConfig(formData)).then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok, data: data };
      });
    }).then(function (result) {
      var data = result.data || {};
      if (!result.ok || data.status) {
        throw new Error(data.description || data.message || 'Could not add this item');
      }

      preferredSeedProductId = data.product_id || preferredSeedProductId;
      justAdded = true;
      button.textContent = 'Added ✓';

      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.renderContents(data);
      } else if (drawer && typeof drawer.open === 'function') {
        drawer.open(button);
      }

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {
          source: 'spp-drawer-upsell',
          cartData: data
        }
      }));

      scheduleRefresh();
    }).catch(function (error) {
      console.error('SPP drawer add error', error);
      button.disabled = false;
      button.textContent = 'Try again';
      window.setTimeout(function () {
        if (button.isConnected) button.textContent = originalText;
      }, 1800);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.spp-drawer-upsell__add');
    if (!button) return;
    event.preventDefault();
    addUpsell(button);
  });

  document.addEventListener('cart:updated', function (event) {
    var detail = event.detail || {};
    var cartData = detail.cartData || {};
    if (cartData.product_id) preferredSeedProductId = cartData.product_id;
    justAdded = true;
    scheduleRefresh();
  });

  function init() {
    var drawer = getDrawer();
    if (!drawer) return;

    fixTaxNote();
    setOpenState();

    var observer = new MutationObserver(function () {
      scheduleRefresh();
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    scheduleRefresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
